import React, { useEffect, useState } from 'react'
import BinaryButtons from '@/components/ui/binary-buttons'

/* Bottom inset the sticky bar covers (h-12 button + 16px padding top and bottom), so the
   list counts as seen only once it clears the bar rather than when it slides under it. */
const STICKY_BAR_HEIGHT = 80

/**
 * Bottom-sticky side buttons for a two-sided fixture on the mobile market page. They stand
 * in for the outcome rows while those are off screen and step aside once the rows — whose
 * accordions open the order book — scroll into view.
 */
const StickyTeamButtons = ({ listNode, firstButton, secondButton }) => {
  const [listInView, setListInView] = useState(true)

  useEffect(() => {
    if (!listNode) return
    const observer = new IntersectionObserver(([entry]) => setListInView(entry.isIntersecting), {
      rootMargin: `0px 0px -${STICKY_BAR_HEIGHT}px 0px`,
    })
    observer.observe(listNode)
    return () => observer.disconnect()
  }, [listNode])

  return (
    <BinaryButtons
      firstButton={firstButton}
      secondButton={secondButton}
      renderPosition="bottom-sticky"
      hidden={listInView}
    />
  )
}

export default StickyTeamButtons
